import OutcomeMeasuresSection from './outcome-measures-section'
export default OutcomeMeasuresSection
